import { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import http from "../api/server";

const Acknowledge = () => {
  const { clientName } = useParams();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const refNo = searchParams.get("refNo");
  const [htmlContent, setHtmlContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const acknowledgeAPI = async () => {
    try {
      const url = `/client/${clientName}/acknowledge-bookingmail`
        .replace(`/client/${clientName}`, "");

      const response = await http.get(url, {
        params: {
          refNo,
        },
        responseType: "text", 
      });

      setHtmlContent(response.data);
    } catch (err) {
      console.error("Acknowledge API failed", err);
      setError("Unable to load acknowledgement page.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (clientName && refNo) {
      acknowledgeAPI();
    } else {
      setError("Invalid acknowledgement link.");
      setLoading(false);
    }
  }, [clientName, refNo]);

  if (loading) {
    return <div style={{ padding: 20 }}>Loading...</div>;
  }

  if (error) {
    return (
      <div style={{ padding: 20, color: "red", textAlign: "center" }}>
        {error}
      </div>
    );
  }

  return (
    <div
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
};

export default Acknowledge;
